import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Nft({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M6.5 14.5V9.50002L9 14.5V9.50002M11.5 14.5V9.50002H13.5M16.5 14.5V9.50002M16.5 9.50002H15.5M16.5 9.50002H17.5M12 12H12.5M20.25 15.705V8.29502C20.25 7.64002 19.901 7.03502 19.333 6.70702L12.916 3.00202C12.349 2.67502 11.65 2.67502 11.083 3.00202L4.667 6.70802C4.099 7.03502 3.75 7.64002 3.75 8.29502V15.704C3.75 16.359 4.099 16.964 4.667 17.292L11.084 20.997C11.651 21.324 12.35 21.324 12.917 20.997L19.334 17.292C19.901 16.965 20.25 16.36 20.25 15.705Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Nft;